import "./LoadingOverlay.css";

/**
 * Consistent blurred backdrop + spinner pill for list/page loading states.
 * Label is page-specific (e.g. "Loading metadata...", "Loading logs...").
 */
export default function LoadingOverlay({
  show = false,
  label = "Loading...",
  className = "",
}) {
  if (!show) {
    return null;
  }

  return (
    <div
      className={`loading-overlay${className ? ` ${className}` : ""}`}
      aria-live="polite"
      aria-busy="true"
      role="status"
    >
      <div className="loading-overlay__pill">
        <span className="loading-overlay__spinner" aria-hidden="true" />
        <span className="loading-overlay__label">{label}</span>
      </div>
    </div>
  );
}
